import {
  Tabs,
  Flex,
  Tooltip,
  Tag,
  Modal,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  message,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  HomeOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import dayjs from "dayjs";
// import "./CompletedTable.scss";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend, CustomUploadNew1 } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);
  const [tabsKeyListFlag] = useState([1, 2, 3, 4, 5]);
  const [accountList, setAccountList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [stateModalFlag, setStateModalFlag] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  const [uploadInvoiceFlag, setUploadInvoiceFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const customUploadNewRef = useRef(null);

  const controllersRef = useRef([])

  const createController = () => {
    const controller = new AbortController()
    controllersRef.current.push(controller)
    return controller
  }

  const cancelAllRequests = () => {
    controllersRef.current.forEach(c => c?.abort())
    controllersRef.current = []
  }

  const initTableHead = {
    requestNo: null,
    status: null,
    materialCostStr: null,
    materialRemark: null,
    jobs: null,
    vendorType: null,
    vendorName: null,
    unitAddress: null,
    city: null,
    supervisor: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: 'Request No',
      dataIndex: "requestNo",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'requestNo')
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'status'),
      render: (text, record) => {
        return (
          <a onClick={() => {
            const url = `${window.location.origin}#/JobRequests/Maintenance/Details?id=${record?.maintenanceId}`;
            window.open(url, "_blank", "noopener,noreferrer");
          }}>
            <Tag color="#3c8dbc">{text}</Tag>
          </a>
        );
      },
    },
    {
      title: "Material Cost",
      dataIndex: "materialCost",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'materialCostStr'),
      render: (text, record) => (
        record?.materialCost ? <span
          onClick={(e) => {
            e.preventDefault();
            setCurrentRecord(record)
            setUploadInvoiceFlag(true)
          }}
          className="custom-border-bottom custom-ellipsis"
          style={{ display: 'inline-block', }}
        >
          {
            commonFn.amountToDollarFn(record?.materialCost)
          }
        </span> : commonFn.amountToDollarFn(record?.materialCost)
      ),
    },
    {
      title: 'Invoice #',
      dataIndex: "invoiceNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'invoiceNumber'),
    },
    {
      title: "Batch",
      dataIndex: "batchNumber",
      hidden: ![-1].includes(tabsKey),
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'batchNumber'),
    },
    {
      title: 'Check Date',
      dataIndex: "checkDate",
      hidden: ![-1].includes(tabsKey),
      titleType: 'DatePicker',
      onChange: (e) => tableFilterFn(e, 'checkDate', 'DatePickerFormat'),
    },
    {
      title: 'Check No',
      dataIndex: "checkNo",
      hidden: ![-1].includes(tabsKey),
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'checkNo'),
    },
    {
      title: "GL Acct",
      dataIndex: "glAcctName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "glAcctName"),
      render: (text, record) => {
        if(!tabsKeyListFlag.includes(tabsKey)){
          return text
        }
        const value = text ? text : 'Empty'
        return (
          <Tooltip title={value}>
            <span
              onClick={(e) => {
                e.preventDefault();
                const {requestNo, glAcct, vendorId, glAcctKey, vendorIdKey} = record
                setCurrentRecord(record)
                form1.setFieldsValue({
                  requestNo, 
                  glAcct: glAcct || glAcctKey, 
                  vendorId: vendorId || vendorIdKey
                })
                setStateModalFlag(true)
              }}
              className="custom-border-bottom custom-ellipsis"
              style={{ display: 'inline-block', }}
            >
              { value }
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "HardWare Store",
      dataIndex: "storeVendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "storeVendorName"),
      render: (text, record) => {
        if(!tabsKeyListFlag.includes(tabsKey)){
          return text
        }
        const value = text ? text : 'Empty'
        return (
          <Tooltip title={value}>
            <span
              onClick={(e) => {
                e.preventDefault();
                const {requestNo, glAcct, vendorId, glAcctKey, vendorIdKey} = record
                setCurrentRecord(record)
                form1.setFieldsValue({
                  requestNo, 
                  glAcct: glAcct || glAcctKey, 
                  vendorId: vendorId || vendorIdKey
                })
                setStateModalFlag(true)
              }}
              className="custom-border-bottom custom-ellipsis"
              style={{ display: 'inline-block', }}
            >
              { value }
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Material Remark",
      dataIndex: "materialRemark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      isWrapFlag: 300,
      onChange: e => tableFilterFn(e, 'materialRemark'),
    },
    {
      title: "Job Type",
      dataIndex: "jobType",
      titleType: 'Input',
      width: 200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'jobs'),
      render: (text) => (
        <Flex gap="4px 0" wrap>
          {text?.map((item) => (
            <Tooltip title={item}>
              <Tag
                  // color="rgba(109, 140, 81, 0.12)"
                color="blue"
                style={{
                    // color: "#6D8C51",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: 'Vendor Type',
      dataIndex: "vendorType",
      titleType: 'Select',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Maint.Woker", value: "1" },
        { label: "Contractor", value: "2" },
      ],
      render: (text) => {
        const requestStatusMatch = {
          "1": "Maint.Woker",
          "2": "Contractor",
        }
        return requestStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'vendorType', 'Select'),
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName'),
      render: (text, record) => {
        return (
          <Tooltip title={record.vendorPhone}>
              {text}
          </Tooltip>
        )
      }
    },
    {
      title: "Unit Address,City",
      dataIndex: "unitAddressCity",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'unitAddressCity')
    },
    // {
    //   title: "City",
    //   dataIndex: "city",
    //   titleType: 'Input',
    //   width: 90,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'city')
    // },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor'),
    },
    {
      title: 'Approved Time',
      dataIndex: "approvedTime",
      width: 90,
      titleType: '',
      isSorter: false,
      render:((text) => text && moment(text).format("MM/DD/YYYY"))
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    const controller = createController()
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      storeId: tabsKey,
      ...tableHead,
    };
    const response = await http.get(api.maintenancePayMaterialShow, { params , signal: controller.signal});
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setSelectedList([])
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setTableList([])
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
    cancelAllRequests()
  }

  const materialShowInvoiceFn = async() => {
    const { maintenanceMaterialInvoiceId } = currentRecord
    setLoading(true)
    const response = await http.get(api.MaterialShowInvoice, {params: { maintenanceMaterialInvoiceId }});
    if (response.code === "1") {
      form.setFieldsValue({
        invoiceAmount: response.data?.invoiceAmount,
        invoiceNumber: response.data?.invoiceNumber,
        invoiceDate: dayjs(response.data?.invoiceDate) || '',
        filePaths: response.data?.fileList?.map(item => item.relativePath)
      })
      customUploadNewRef.current.initUpdateList(response.data?.fileList?.map(item => ({...item, allPath: item.url, name: item?.name || item?.fileName})));
    } else {
      message.error(response.msg || "Failed to fetch user data");
    }
    setLoading(false)
  }

  const approvalBeforeFn = () => {
    Modal.confirm({
      title: "Confirm Send For Check Approval",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to send for check approval the selected data?",
      okText: "Sure",
      cancelText: "Cancel",
      onOk() {
        approvalFn();
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  }

  const approvalFn = async() => {
    setApprovalLoading(true)
    const response = await http.post(api.maintenancePayMaterialSendToVendorPayment, {idList: selectedList.map(item => item.maintenanceMaterialInvoiceId)});
    if (response.code === "1") {
      message.success("Send For Check Approval successfully");
      getTableListFn(1, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setApprovalLoading(false)
  }

  const changeStateFn = async() => {
    setLoading(true)
    const response = await http.get(api.maintenancePayMaterialAddGlAcctToInfo, {params: {id: currentRecord.maintenanceMaterialInvoiceId, ...form1.getFieldValue()}});
    if (response.code === "1") {
      message.success("Edit successfully");
      setStateModalFlag(false)
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setLoading(false)
  }

  const getGlAccountListFn = async() => {
    const response = await http.get(api.getGLAccountList);
    const temp = (response?.data || [])?.map((item) => ({
      label: item.glAcctTitle,
      value: item.glAcct,
    }));
    setAccountList(temp)
  }

  const getVendorListFn = async() => {
    const response = await http.get(api.materialVendorStoreVendor, {params: {storeId: tabsKey}});
    if (!response) return
    const temp = (response?.data || [])?.map((item) => ({
      label: item.vendorName,
      value: item.vendorId,
    }));
    setVendorList(temp)
  }

  useEffect(() => {
    if(uploadInvoiceFlag){
      materialShowInvoiceFn()
    }
  }, [uploadInvoiceFlag])

  useEffect(() => {
    if(!accountList?.length){
      getGlAccountListFn()
    }
    getVendorListFn()
  }, [tabsKey])

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <Tabs 
          defaultActiveKey={tabsKey} 
          items={[
            {key: 1, label: "HomeDepot"},
            {key: 2, label: "Foothill"},
            {key: 3, label: "Valle Vista"},
            {key: 4, label: "Max's"},
            {key: 5, label: "Ropain Appliance Inc"},
            {key: 0, label: "Send For Approval"},
            {key: -1, label: "Material Paid"},
          ]}
          onChange={key => (setTabsKey(key), setRefreshKey(+new Date()))}
        />
      </CustomTableExtend>

      {tabsKeyListFlag.includes(tabsKey) && (
        <commonFn.BtnAuthorityFn authKey="sendForApproval">
          <Button type="primary" style={{marginBottom: 20}} onClick={() => approvalBeforeFn()} loading={approvalLoading}>
            <CheckOutlined />
            Send For Check Approval
          </Button>
        </commonFn.BtnAuthorityFn>
      ) || null}

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={tabsKeyListFlag.includes(tabsKey) && {
          preserveSelectedRowKeys: true,
          type: "checkbox",
          getCheckboxProps: (record) => ({
            disabled: !(record?.glAcct && record?.vendorId) 
          }),
          selectedRowKeys: selectedList.map(item => item.maintenanceMaterialInvoiceId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="maintenanceMaterialInvoiceId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="380px"
      />

      <Modal
        title="Select GL Account Or Vendor"
        width="50%"
        maskClosable={false}
        open={stateModalFlag}
        onCancel={() => setStateModalFlag(false)}
        footer={[
          <Button key="back" onClick={() => setStateModalFlag(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form1.submit()}
          >
            Submit
          </Button>
        ]}
      >
        <Form
          form={form1}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={changeStateFn}
          validateMessages={{
            required: "${label} is required!",
          }}
        > 
          <Form.Item name="requestNo" label="Request No">
            <Input
              disabled
              placeholder="Please input Request No"
            />
          </Form.Item>

          <Form.Item 
            name="glAcct" 
            label="GL Acct"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Please select GL Account"
              options={accountList}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item 
            name="vendorId" 
            label="Vendor Name" 
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Please select Vendor Name"
              options={vendorList}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="View Invoice"
        width="80%"
        maskClosable={false}
        open={uploadInvoiceFlag}
        onCancel={() => (setUploadInvoiceFlag(false))}
        footer={false}
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
        >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item
              name="invoiceDate"
              label="Invoice Date"
              rules={[{ required: true, message: "Invoice Date is required!" }]}
            >
              <DatePicker
                disabled
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
                getPopupContainer={(trigger) => trigger.parentElement}
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              name: 'invoiceAmount', 
              label: 'Invoice Amount',
              form,
              disabled: true,
              // isNoRequired: true,
              validator: (_, value, callback) => {
                if(value >= 1000000){
                  callback('The Amount Must Be Between 0 And 1000000.')
                } else {
                  callback()
                }
              }
            })}

            <Form.Item
              name="invoiceNumber"
              label="Invoice #"
              rules={[{ required: true, message: 'Invoice # is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input Invoice #"
              />
            </Form.Item>
          </Col>
          <Col span={16}>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <HomeOutlined style={{ marginRight: "8px" }} />
            Files
          </div>
          <Form.Item
            name="filePaths" 
            label="Files"
            labelCol={{ span: 0 }} 
            wrapperCol={{ span: 24 }}
            rules={[{ required: true, message: "Files is required!" }]}
          >
            <CustomUploadNew1
              ref={(el) => (customUploadNewRef.current = el)}
              customConfig={{
                pdfHeight: "76vh",
                notMultiple: true,
                accept: ".jpg, .jpeg, .png, .pdf",
                status: 'add',
                disabled: true,
                noUploadBtn: true
              }}
              setFilePaths={setFilePaths} 
              filePaths={filePaths} 
              setBtnDisabled={setBtnDisabled}
              btnDisabled={btnDisabled}
            />
          </Form.Item>
          </Col>
        </Row>
        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;
